import { Box, Flex, Image } from '@chakra-ui/react';
import { useEffect } from 'react';

import loginImage from 'Asset/image/login-image.jpg';
import useIsMobile from 'Hook/useIsMobile';
import { Condition } from 'Component/others';

import ForgotPasswordProvider from 'View/forgot-password/state';
import { useForgotPasswordState } from 'View/forgot-password/state';
import Form from './section/form';
import Head from './section/head';
import RequestSent from './section/request-sent';
import styles from './styles.module.css';

const ForgotPassword = () => {
  const isMobile = useIsMobile();
  const { state, resetState } = useForgotPasswordState();

  useEffect(() => {
    resetState();
  }, [resetState]);

  return (
    <Flex className={styles['forgot-password__container']}>
      <Box className={styles['section__container--left']}>
        <Image src={loginImage} className={styles['forgot-password__image']} />
      </Box>
      <Box className={styles['section__container--right']}>
        <Box className={styles['box__container']}>
          <Condition statement={!state?.isSent && !state?.isResent}>
            <Head />
            <Form />
          </Condition>

          <Condition statement={state?.isSent || state?.isResent}>
            <Condition statement={isMobile}>
              <Head isSent={true} />
            </Condition>
            <RequestSent />
          </Condition>
        </Box>
      </Box>
    </Flex>
  );
};

const ForgotPasswordContainer = () => <ForgotPasswordProvider children={<ForgotPassword />} />;

export default ForgotPasswordContainer;
